module.exports = __webpack_public_path__ + "static/media/abacus.fecbe139.jpg";